export const COPILOT_PROCESSING_WORKING_LAYER_SCROLL_DISMISS_PX = 24;

type ShouldDismissCopilotProcessingWorkingLayerParams = {
  anchorScrollTop: number;
  currentScrollTop: number;
  isTrusted: boolean;
  isAlreadyDismissed: boolean;
};

export function shouldDismissCopilotProcessingWorkingLayer({
  anchorScrollTop,
  currentScrollTop,
  isTrusted,
  isAlreadyDismissed,
}: ShouldDismissCopilotProcessingWorkingLayerParams): boolean {
  if (isAlreadyDismissed || !isTrusted) {
    return false;
  }

  const scrollDisplacement = Math.abs(currentScrollTop - anchorScrollTop);

  return (
    scrollDisplacement > COPILOT_PROCESSING_WORKING_LAYER_SCROLL_DISMISS_PX
  );
}
